import {
  CellApiModule,
  CellSpanModule,
  CellStyleModule,
  ClientSideRowModelApiModule,
  ClientSideRowModelModule,
  ColumnApiModule,
  ColumnAutoSizeModule,
  EventApiModule,
  GridStateModule,
  LocaleModule,
  ModuleRegistry,
  PaginationModule,
  PinnedRowModule,
  QuickFilterModule,
  RenderApiModule,
  RowApiModule,
  RowAutoHeightModule,
  RowDragModule,
  RowSelectionModule,
  RowStyleModule,
  ScrollApiModule,
  TooltipModule,
  ValidationModule,
  ValueCacheModule,
} from 'ag-grid-community';
import {
  CellSelectionModule,
  ClipboardModule,
  ColumnMenuModule,
  ContextMenuModule,
  GroupFilterModule,
  MasterDetailModule,
  PivotModule,
  RowGroupingModule,
  RowGroupingPanelModule,
  SetFilterModule,
  StatusBarModule,
} from 'ag-grid-enterprise';

export function registerAgGridModules(): void {
  const modules = [
    ColumnAutoSizeModule,
    PinnedRowModule,
    RowAutoHeightModule,
    RowStyleModule,
    PaginationModule,
    RowDragModule,
    CellSpanModule,
    CellStyleModule,
    TooltipModule,
    QuickFilterModule,
    RowSelectionModule,
    LocaleModule,
    ValueCacheModule,
    GridStateModule,
    ColumnApiModule,
    RowApiModule,
    CellApiModule,
    ScrollApiModule,
    RenderApiModule,
    EventApiModule,
    ClientSideRowModelApiModule,
    ClientSideRowModelModule,
    CellSelectionModule,
    RowGroupingModule,
    RowGroupingPanelModule,
    GroupFilterModule,
    PivotModule,
    MasterDetailModule,
    ColumnMenuModule,
    ContextMenuModule,
    ClipboardModule,
    ValidationModule,
    SetFilterModule,
    StatusBarModule,
  ];

  ModuleRegistry.registerModules(modules);

  if (process.env.NODE_ENV === 'development') {
    console.log(
      'AG Grid modules registered:',
      modules.map((m) => m.moduleName),
    );
  }
}
